module.exports = __webpack_public_path__ + "static/LJ-d7624ab79a0e21936dd71a9078be5a8c.png";